import {useEffect} from 'react';

export const lifecycle = {
  componentDidMount: async (state: any, props: any) => {
    const {setLoading} = state;
    const {actions, news} = props;

    const _useEffect = async () => {
      try {
        if (news.pages.active.length === 0 || window.isInitial) {
          setLoading(true);

          await actions.news.getPagination(
            news.current,
            news.searchWords,
            news.sortState
          );

          setLoading(false);

          window.isInitial = false;
        }
      } catch (error) {
        console.error(error);
        setLoading(false);
      }
    };

    useEffect(() => {
      _useEffect();
    }, []);
  },
};
